import { combineReducers } from 'redux'
import employerActiveFilter from 'store/employer-active-filter/reducer'
import reports from 'store/reports/reducer'
import contractorActiveFilter from 'store/contractor-active-filter/reducer'
import menuSelectedState from 'store/menu-selected/reducer'
import menuState from 'store/menu-state/reducer'
import sites from 'store/sites/reducer'
import currentSite from 'store/current-site/reducer'
import fireRollCall from 'store/fire-roll-call/reducer'
import permissions from 'store/permissions/reducer'
import features from 'store/features/reducer'
import reportViewerState from 'store/report-viewer/reducer'
import selectedReportRow from 'store/report-row/reducer'
import passes from 'store/passes/reducer'
import user from 'store/user/reducer'
import currentEmployer from 'store/current-employer/reducer'

const rootReducer = combineReducers({
  employerActiveFilter,
  contractorActiveFilter,
  menuSelectedState,
  menuState,
  sites,
  currentSite,
  fireRollCall,
  permissions,
  features,
  reports,
  passes,
  reportViewerState,
  selectedReportRow,
  user,
  currentEmployer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js